export default __webpack_public_path__ + "static/media/paymentTimeout.6f13958b.gif";